import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import classNames from "classnames";
import { useIntl } from "react-intl";
import {
  Row,
  Col,
  Form,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  Card,
  CardHeader,
  CardBody,
} from "../../../_metronic/_partials/controls";
import * as actions from "../../../store/actions/index";
import { getDemoMode } from "../../../helpers";
import axios from "../../../config/AxiosConfig";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  CLEAR_CACHE_API,
  CLEAN_DATABASE_API,
} from "../../../store/actions/apiCollections";
import { authCheckState } from "../../../store/actions/index";
import "./TestingEnvironment.scss";
export const TestingEnvironment = () => {
  const demoMode = getDemoMode();
  const intl = useIntl();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const maintainanceModeList = [
    {
      value: "yes",
      label: intl.formatMessage({ id: "GLOBAL.YES" }),
    },
    {
      value: "no",
      label: intl.formatMessage({ id: "GLOBAL.NO" }),
    },
  ];

  useEffect(() => {
    dispatch(actions.getGeneralSettings());
    dispatch(authCheckState());
  }, [dispatch]);

  const { generalSettings, loading } = useSelector((state) => state.settings);
  const { currentPermissions } = useSelector((state) => state.role);
  useEffect(() => {
    const getGeneralSettingsDetail = {
      id: generalSettings?.id,
      maintainanceMode: generalSettings?.maintainanceMode,
      exceptIP: generalSettings?.exceptIP,
    };

    reset({ ...getGeneralSettingsDetail });
     
  }, [generalSettings]);

  const MySwal = withReactContent(Swal);
  const alertBox = (text, icon) => {
    MySwal.fire({
      title: text,
      icon: icon,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result["isConfirmed"]) {
        dispatch(actions.getGeneralSettings());
      }
    });
  };

  const onCleanDataOnly = () => {
    MySwal.fire({
      title: intl.formatMessage({ id: "maintenanceMode.clean.confirm" }),
      icon: "warning",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(CLEAN_DATABASE_API, { params: { lng: "en" } })
          .then((response) => {
            const { message, skippedCollections = [] } =
              response.data?.data ?? {};
            if (skippedCollections.length > 0) {
              Swal.fire(
                message,
                intl.formatMessage(
                  { id: "maintenanceMode.clean.skipped" },
                  { collections: skippedCollections.join(", ") }
                ),
                "warning"
              );
              return;
            }
            Swal.fire(message, "", "success");
          })
          .catch((err) => {
            console.log(err);
            Swal.fire(
              intl.formatMessage({ id: "maintenanceMode.clean.failed" }),
              "",
              "error"
            );
          });
      }
    });
  };

  const onClearCache = () => {
    MySwal.fire({
      title: intl.formatMessage({ id: "maintenanceMode.clearCache.confirm" }),
      icon: "warning",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(CLEAR_CACHE_API, { params: { lng: "en" } })
          .then((response) => {
            Swal.fire(response.data?.data, "", "success");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const onSubmit = (data) => {
    let generalSettingData = new FormData();
    generalSettingData.append("id", data.id);
    generalSettingData.append("maintainanceMode", data.maintainanceMode);
    generalSettingData.append("exceptIP", data.exceptIP);
    dispatch(actions.updateGeneralSettings(generalSettingData));
    alertBox(intl.formatMessage({ id: "MAINTENANCEMODE.SUCESS" }), "success");
  };

  return (
    <>
      <Card>
        <CardHeader
          title={intl.formatMessage({ id: "maintenanceMode.title" })}
        />
        <CardBody className="pt-0 pb-6 px-4">
          <Row className="justify-content-md-center">
            <Col md={11}>
              <Form
                className="form form-label-right"
                onSubmit={handleSubmit(onSubmit)}>
                <Form.Control type="hidden" name="id" {...register("id")} />
                <div className="form-group d-flex flex-column align-items-start mb-7">
                  <label className="font-size-sm text-black fw-medium mb-3">
                    {intl.formatMessage({
                      id: "MAINTENANCEMODE",
                    })}
                    <span className="text-important"> *</span>
                  </label>

                  <div>
                    {maintainanceModeList.map((option) => (
                      <div
                        key={option.value}
                        className="form-check form-check-inline">
                        <input
                          type="radio"
                          id={`maintainanceMode-${option.value}`}
                          value={option.value}
                          className={classNames("form-check-input", {
                            "is-invalid": errors.maintainanceMode,
                          })}
                          {...register("maintainanceMode", {
                            required: intl.formatMessage({
                              id: "COMMON.FIELD.REQ",
                            }),
                          })}
                        />
                        <label
                          htmlFor={`maintainanceMode-${option.value}`}
                          className="form-check-label text-black cursor-pointer fw-medium">
                          {option.label}
                        </label>
                      </div>
                    ))}
                  </div>

                  <ErrorMessage
                    errors={errors}
                    name="maintainanceMode"
                    render={({ message }) => (
                      <div className="invalid-feedback d-block">{message}</div>
                    )}
                  />
                </div>

                <div className="floating-input-field-wrapper mb-10">
                  <Form.Control
                    name="exceptIP"
                    className={classNames(
                      "form-control floating-input-field-item",
                      {
                        "is-invalid": errors.exceptIP,
                      }
                    )}
                    placeholder=" "
                    {...register("exceptIP", {
                      required: intl.formatMessage({ id: "COMMON.FIELD.REQ" }),

                      pattern: {
                        value:
                          /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/,
                        message: intl.formatMessage({
                          id: "IPADDRESS.ERROR",
                        }),
                      },
                    })}
                  />
                  <label className="floating-input-field-label ms-4 start-0">
                    {intl.formatMessage({
                      id: "IPADDRESS",
                    })}
                    <span className="text-important"> *</span>
                  </label>
                  <ErrorMessage
                    errors={errors}
                    name="exceptIP"
                    render={({ message }) => (
                      <div className="invalid-feedback">{message}</div>
                    )}
                  />
                </div>
                {demoMode === "false" ? (
                  <div className="d-flex flex-column flex-md-row gap-5 align-items-start align-items-md-center mt-7 mb-5">
                    {currentPermissions?.update_maintenance_mode && (
                      <button
                        type="submit"
                        className="btn btn-secondary common-save-btn">
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"></span>
                        ) : (
                          "Update"
                        )}
                      </button>
                    )}
                    {currentPermissions?.clear_cache && (
                      <button
                        type="button"
                        className="clear-cache-btn ms-md-auto"
                        onClick={onClearCache}>
                        <SVG
                          className="me-2"
                          height={18}
                          width={18}
                          src={toAbsoluteUrl(
                            "media/svg/icons/General/trash-white.svg"
                          )}
                        />
                        Clear Cache
                      </button>
                    )}
                    {currentPermissions?.clear_data && (
                      <button
                        type="button"
                        className="clean-data-btn"
                        onClick={onCleanDataOnly}>
                        <SVG
                          height={18}
                          width={18}
                          className="me-2"
                          src={toAbsoluteUrl(
                            "media/svg/icons/General/brush.svg"
                          )}
                        />
                        Clean Data Only
                      </button>
                    )}
                  </div>
                ) : null}
              </Form>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};
